import { render } from "./BaseLoader.vue?vue&type=template&id=380db0e9&scoped=true"
const script = {}

import "./BaseLoader.vue?vue&type=style&index=0&id=380db0e9&scoped=true&lang=scss"

import exportComponent from "/builds/digithia/cap-emploi/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380db0e9"]])

export default __exports__